import { Box, SxProps, Theme } from '@mui/material';
import { usePathsV2 } from 'core/services/navigation/usePathsV2';
import { CandidateProfileList } from 'modules/candidate-profile/components/CandidateProfileList';
import {
  CandidateListTab,
  useCandidateListStore
} from 'modules/candidate-profile/stores/useCandidateListStore';
import { CandidateProfileListType } from 'modules/candidate-profile/types/CandidateProfileListProps';
import { CandidateProfileTalentPoolTable } from 'modules/candidate-profile/tables/CandidateProfileTalentPoolTable';

const getTabPanelSx = (isActive: boolean): SxProps<Theme> => ({
  display: isActive ? 'block' : 'none'
});

export const AnalyseCandidateProfileList: React.FC = () => {
  const { getPathParams } = usePathsV2();
  const { candidateBatchId } = getPathParams.ANALYSE_CANDIDATE_PROFILE_LIST();
  const { activeTab } = useCandidateListStore();

  return (
    <>
      <Box sx={getTabPanelSx(activeTab === CandidateListTab.CANDIDATES)}>
        <CandidateProfileList
          type={CandidateProfileListType.ANALYSIS_CANDIDATES_LIST}
          candidateBatchId={candidateBatchId}
        />
      </Box>
      <Box sx={getTabPanelSx(activeTab === CandidateListTab.TALENT_LISTS)}>
        <CandidateProfileTalentPoolTable
          type={CandidateProfileListType.ANALYSIS_CANDIDATES_LIST}
          candidateBatchId={candidateBatchId}
        />
      </Box>
    </>
  );
};
